import { cn } from '@forest/shared'
import { m } from '~/paraglide/messages'

export function CtaBubble(props: { className?: string }) {
  return (
    <div
      className={cn(
        'relative flex h-9 items-center rounded-full bg-white/10 px-4',
        props.className,
      )}
    >
      {/* Arrow */}
      <svg
        width="12"
        height="10"
        viewBox="0 0 12 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute left-1/2 top-full -translate-x-1/2"
      >
        <path
          d="M6.85749 8.57084L12 0L0 0L5.14251 8.57084C5.53091 9.21818 6.46909 9.21818 6.85749 8.57084Z"
          fill="white"
          fillOpacity="0.1"
        />
      </svg>

      {m.closing_appstore_label()}
    </div>
  )
}
